import * as React from 'react';
import { Table, CustomButton, ButtonType, TextInput } from "soprasteria-ui-library";
import { IEmergencyTreatmentsModel } from '../../../models/IEmergencyTreatment';
import { formatCurrency } from '../../../helpers/CurrencyHelper';

interface IEmergencyTreatmentsTable {
    registeredTreatments: IEmergencyTreatmentsModel;
    canAddPatientTreatment: boolean;
    onTreatmentDelete: (treatmentId: number) => void;
    onTreatmentCredit: (patientTreatmentId: number) => void;
}

export const EmergencyTreatmentsTable: React.FunctionComponent<IEmergencyTreatmentsTable> = ({ registeredTreatments, canAddPatientTreatment, onTreatmentDelete, onTreatmentCredit }) => {

    const removeTreatment = (patientTreatmentId: number) => {
        const removeTreatment = window.confirm("Är du säker på att du vill ta bort den här åtgärdskoden?");
        if (removeTreatment) {
            onTreatmentDelete(patientTreatmentId);
        }
    }

    const creditTreatment = (patientTreatmentId: number) => {
        const creditTreatment = window.confirm("Är du säker på att du vill markera den här åtgärdskoden för kreditering?");
        if (creditTreatment) {
            onTreatmentCredit(patientTreatmentId);
        }
    }

    const isAnyTreatmentCreditable = () => {
        return registeredTreatments.treatments.some((treatment) => treatment.isCreditable);
    }

    const canAnyTreatmentBeRemoved = () => {
        return registeredTreatments.treatments.some((treatment) => treatment.canBeRemoved);
    }

    return (
        <div className="row">
            <div className="col-12">
                <Table>
                    <thead>
                        <tr>
                            <th>Åtgärdskod</th>
                            <th>Rubrik</th>
                            <th>Antal</th>
                            <th className="text-right">à-pris</th>
                            <th className="text-right">Summa</th>
                            <th>Status</th>
                            {
                                registeredTreatments.treatments.length > 0 && (canAnyTreatmentBeRemoved() || isAnyTreatmentCreditable()) ?
                                    <th></th>
                                    : null
                            }
                        </tr>
                    </thead>
                    <tbody>

                        {
                            registeredTreatments.treatments.length > 0 ?
                                registeredTreatments.treatments.map((treatment, key) => {
                                    return (
                                        <tr key={key}>
                                            <td>{treatment.code}</td>
                                            <td>{treatment.description}</td>
                                            <td>{treatment.quantity}</td>
                                            <td className="text-right text-nowrap">{formatCurrency(treatment.pricePcs)}</td>
                                            <td className="text-right text-nowrap">{formatCurrency(treatment.totalPrice)}</td>
                                            <td>{treatment.status}</td>
                                            {
                                                canAnyTreatmentBeRemoved() || isAnyTreatmentCreditable() ?
                                                    <td className="delete-btn">
                                                        {
                                                            treatment.isCreditable ?
                                                                <CustomButton
                                                                    buttonType={ButtonType.warning}
                                                                    onClick={() => creditTreatment(treatment.patientTreatmentId ?? 0)}
                                                                    buttonText="Kreditera" />
                                                                : null
                                                        }
                                                        {
                                                            treatment.canBeRemoved ?
                                                                <CustomButton
                                                                    buttonType={ButtonType.delete}
                                                                    onClick={() => removeTreatment(treatment.patientTreatmentId ?? 0)}
                                                                    buttonText="" />
                                                                : null}
                                                    </td>
                                                    : null
                                            }
                                        </tr>
                                    )

                                })
                                : <tr><td colSpan={registeredTreatments.treatments.length > 0 && (canAddPatientTreatment || isAnyTreatmentCreditable()) ? 7 : 6}>Det finns inga genomförda åtgärdskoder registrerade</td></tr>
                        }
                    </tbody>
                </Table>
            </div>
            {
                registeredTreatments.treatments.length > 0 ?
                    <>
                        <div className="col-10">
                        </div>
                        <div className="col-2 text-right">
                            <TextInput label="Totalsumma" name="totalSumReadOnly" defaultValue={formatCurrency(registeredTreatments.totalPrice)} inlineLabel readonly labelCol={7} inputCol={5} />
                        </div>
                    </>
                    : null
            }
        </div>
    );
}